export default "__VITE_ASSET__DgvZdi9y__"